import { Badge, Tooltip } from 'framework/ui/mui-builder';
import { GAP_DETAILS } from '../../constants';

type GapTagProps = {
  code: string;
  title?: string;
};

export const getGapGroup = (code: string) => GAP_DETAILS[code]?.group ?? 'model';

const GAP_TAG_SX = {
  structure: { color: 'warning.main', borderColor: 'warning.main' },
  model: { color: 'text.primary', borderColor: 'border.default' },
  info: { color: 'text.secondary', borderColor: 'border.default' },
} as const;

const GapTag = ({ code, title }: GapTagProps) => (
  <Tooltip title={title || GAP_DETAILS[code]?.hint || code}>
    <span>
      <Badge
        variant="outlined"
        sx={{
          marginLeft: 0,
          backgroundColor: 'background.default',
          whiteSpace: 'nowrap',
          cursor: 'help',
          ...GAP_TAG_SX[getGapGroup(code)],
        }}
      >
        {GAP_DETAILS[code]?.label ?? code}
      </Badge>
    </span>
  </Tooltip>
);

export default GapTag;
